<template>
  <div class="comment-input">
    <!-- 已登录显示头像，未登录显示登录按钮 -->
    <template v-if="isLoggedIn">
      <img
        v-if="userAvatar"
        class="comment-input__avatar"
        :src="userAvatar"
        alt="头像"
      />
      <div v-else class="comment-input__avatar comment-input__avatar--default">
        <span>我</span>
      </div>
    </template>
    <button
      v-else
      class="comment-input__login-btn"
      @click="onLogin"
    >
      未登录
    </button>

    <input
      v-model="message"
      class="comment-input__field"
      :class="{ 'comment-input__field--disabled': !isLoggedIn }"
      type="text"
      placeholder="写评论..."
      :disabled="!isLoggedIn"
      @keyup.enter="onSend"
    />
    <button
      class="comment-input__send"
      :class="{ 'comment-input__send--disabled': !isLoggedIn || !message.trim() }"
      :disabled="!isLoggedIn || !message.trim()"
      @click="onSend"
    >
      发送
    </button>
    <button class="comment-input__like" @click="onLike">
      <span class="comment-input__like-icon" :class="{ 'comment-input__like-icon--active': liked }">👍</span>
      <span v-if="likes > 0" class="comment-input__like-count">{{ likes }}</span>
    </button>
    <button class="comment-input__favorite" @click="onFavorite">
      <span class="comment-input__favorite-icon" :class="{ 'comment-input__favorite-icon--active': favorited }">★</span>
    </button>
    <button class="comment-input__share" @click="onShare">
      <img src="../assets/img/fenxiang.png" alt="分享" class="comment-input__share-icon" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'CommentInput',
  props: {
    likeCount: { type: Number, default: 0 },
    isLiked: { type: Boolean, default: false },
    isFavorited: { type: Boolean, default: false },
    isLoggedIn: { type: Boolean, default: false },
    userAvatar: { type: String, default: '' }
  },
  data() {
    return {
      message: '',
      likes: this.likeCount,
      liked: this.isLiked,
      favorited: this.isFavorited
    };
  },
  watch: {
    likeCount(val) {
      this.likes = val;
    },
    isLiked(val) {
      this.liked = val;
    },
    isFavorited(val) {
      this.favorited = val;
    }
  },
  methods: {
    onSend() {
      if (!this.isLoggedIn || !this.message.trim()) return;
      this.$emit('send', this.message);
      this.message = '';
    },
    onLogin() {
      this.$emit('login');
    },
    onLike() {
      if (!this.isLoggedIn) {
        this.$emit('login');
        return;
      }
      this.$emit('like', !this.liked);
    },
    onFavorite() {
      if (!this.isLoggedIn) {
        this.$emit('login');
        return;
      }
      this.$emit('favorite', !this.favorited);
    },
    onShare() {
      this.$emit('share');
    }
  }
};
</script>

<style scoped>
.comment-input {
  display: flex;
  align-items: center;
  width: var(--page-width);
  height: 96px;
  padding: 0 var(--space-6);
  box-sizing: border-box;
  background-color: #f7f7f7;
  border-top: 1px solid #eeeeee;
}

.comment-input__avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  margin-right: var(--space-3);
}

.comment-input__avatar--default {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ddd;
  color: #fff;
  font-size: var(--font-lg);
}

.comment-input__login-btn {
  flex-shrink: 0;
  height: 56px;
  padding: 0 var(--space-4);
  margin-right: var(--space-3);
  background-color: var(--color-primary);
  color: var(--color-white);
  font-size: var(--font-base);
  font-family: var(--font-primary);
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
}

.comment-input__field {
  flex: 1;
  height: 60px;
  padding: 0 var(--space-4);
  border: 1px solid #dddddd;
  border-radius: var(--radius-full);
  background-color: var(--color-white);
  color: var(--color-text-dark);
  font-size: var(--font-base);
  font-family: var(--font-primary);
  outline: none;
}

.comment-input__field::placeholder {
  color: var(--color-text-light);
}

.comment-input__field--disabled {
  background-color: #f0f0f0;
  cursor: not-allowed;
}

.comment-input__send {
  width: 88px;
  height: 56px;
  margin-left: var(--space-3);
  background-color: var(--color-primary);
  color: var(--color-white);
  font-size: var(--font-base);
  font-family: var(--font-primary);
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
}

.comment-input__send--disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.comment-input__like,
.comment-input__favorite,
.comment-input__share {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-left: var(--space-3);
  background-color: var(--color-white);
  border: 1px solid #dddddd;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
}

.comment-input__like-icon,
.comment-input__favorite-icon,
.comment-input__share-icon {
  font-size: var(--font-lg);
  color: var(--color-text-gray);
}

.comment-input__like-icon--active {
  color: #b0000b;
}

.comment-input__favorite-icon--active {
  color: #ff9900;
}

.comment-input__like-count {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  background-color: var(--color-primary);
  color: var(--color-white);
  font-size: var(--font-xs);
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
}

.comment-input__share-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
</style>
